var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDots = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00016 8.3335C4.0835 8.3335 3.3335 9.0835 3.3335 10.0002C3.3335 10.9168 4.0835 11.6668 5.00016 11.6668C5.91683 11.6668 6.66683 10.9168 6.66683 10.0002C6.66683 9.0835 5.91683 8.3335 5.00016 8.3335ZM15.0002 8.3335C14.0835 8.3335 13.3335 9.0835 13.3335 10.0002C13.3335 10.9168 14.0835 11.6668 15.0002 11.6668C15.9168 11.6668 16.6668 10.9168 16.6668 10.0002C16.6668 9.0835 15.9168 8.3335 15.0002 8.3335ZM10.0002 8.3335C9.0835 8.3335 8.3335 9.0835 8.3335 10.0002C8.3335 10.9168 9.0835 11.6668 10.0002 11.6668C10.9168 11.6668 11.6668 10.9168 11.6668 10.0002C11.6668 9.0835 10.9168 8.3335 10.0002 8.3335Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDots);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_dots.a1a14c15f3ea802e3aa0f0b787241b1f.svg";